import { Box, Button, Flex, Link, TextField } from '@iheartjane/reefer';
import type { SyntheticEvent } from 'react';

import { UnlockWalletWrapper } from '@jane/monolith/components/cart/pendingCartDrawer/cartDrawerSpecials/customerLoyaltyPoints/customerLoyaltyPoints.styles';

export const VerificationCodeForm = ({
  error,
  headless,
  onBlur,
  onCancel,
  onChange,
  onSubmit,
  unlockLoading,
  displayError,
}: {
  displayError: boolean;
  error?: string;
  headless?: boolean;
  onBlur: () => void;
  onCancel: () => void;
  onChange: (value: string) => void;
  onSubmit: (e: SyntheticEvent) => void;
  unlockLoading: boolean;
}) => (
  <UnlockWalletWrapper headless={headless}>
    <Flex alignItems="flex-start" flexDirection="column">
      Enter your verification code
      <TextField
        width="100%"
        label=""
        name="verification-code"
        helperText={displayError && error}
        onChange={onChange}
        onBlur={onBlur}
        placeholder="Verification code"
      />
      <Box mt={16}>
        <Button
          onClick={onSubmit}
          disabled={Boolean(error)}
          variant="secondary"
          loading={unlockLoading}
          label="Submit"
          mr={20}
        />
        <Link onClick={onCancel}>Cancel</Link>
      </Box>
    </Flex>
  </UnlockWalletWrapper>
);
